import React from 'react';
import {OmitStrict} from '@wix/devzai-utils-common';
import {useIsWidgetInFixedHeight} from '../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context';
import {
    DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons
} from '../doppe-action-type-widget-content-layout-new-sections-and-buttons/doppe-action-type-widget-content-layout-new-sections-and-buttons';

export const DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons = React.memo(function DoppeActionTypeWidgetContentLayoutNewWrapper (props: DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons.Props) {

    const isWidgetInFixedHeight = useIsWidgetInFixedHeight();

    return (
        <DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons
            {...props}
            isFixedHeight={isWidgetInFixedHeight}
            fullWidthMainMedia={props.fullWidthMainMedia ?? isWidgetInFixedHeight ? true : undefined}
        />
    );
});

export namespace DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons {

    export interface Props extends OmitStrict<DoppeActionTypeWidgetContentLayoutNewSectionsAndButtons.Props, 'isFixedHeight'> {
    }
}
